import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { UserAuthenticatedLayout } from "@/layouts/AuthenticatedLayout/UserAuthenticatedLayout";
import { EmptyList } from "@/modules/theme/components/EmptyList/EmptyList";
import { PageMeta } from "@/modules/theme/components/PageMeta";
import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

const translationNamespace = "pages/TasksPage";

export const EmptyTasksView = () => {
  const { t } = useTranslation(translationNamespace);
  const classes = createEmptyTasksViewStyles(useTheme());

  return (
    <UserAuthenticatedLayout containerClassName={classes.root}>
      <PageMeta title={t("Tasks")} />
      <Typography variant="pageHeading" className={classes.heading}>
        {t("Tasks")}
      </Typography>
      <EmptyList>
        <>
          <Typography variant="contentMedium" className={classes.emptyListText}>
            {t("There are no tasks for you today")}
          </Typography>
        </>
      </EmptyList>
    </UserAuthenticatedLayout>
  );
};

const createEmptyTasksViewStyles = ({ spacing }: Theme) => {
  return {
    root: css({
      position: "relative",
    }),
    heading: css({
      marginBottom: spacing(3),
    }),
    emptyListText: css({
      textAlign: "center",
    }),
  };
};
